import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {VirtualWorkbookWorksheetService} from '@features/spreadsheet/services/virtual-workbook-worksheet.service';
import {FlexSheetService} from '@features/spreadsheet/services/flex-sheet.service';
import {FlexSheetDataService} from '@features/spreadsheet/services/flex-sheet-data.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {catchError, map, take} from 'rxjs/operators';
import {FileSelectorModel} from "@features/file-manager/models/file-selector.model";
import {DialogService} from "@shared/services/dialog-service";
import {SnackBarService} from "@core/services/snack-bar.service";
import {FileManagementService} from "@core/services/file-management.service";
import {DownloadFileByRelativePathFailedAction, DownloadFileByRelativePathSuccessAction} from '@shared/store/actions/file-store.actions';
import {of} from 'rxjs';
import {PlatformToolSpreadsheetHandler} from "@features/spreadsheet/services/platform-tool-spreadsheet-handler";

@Component({
    standalone: false,
    selector: 'app-virtual-place-holder',
  templateUrl: './virtual-place-holder.component.html',
  styleUrls: ['./virtual-place-holder.component.scss'],
  encapsulation:  ViewEncapsulation.None
})
export class VirtualPlaceHolderComponent implements OnInit {

  constructor(private virtualWorkbookWorksheetService: VirtualWorkbookWorksheetService,
              public flexSheetService: FlexSheetService,
              public dialogService: DialogService,
              public snackBarService: SnackBarService,
              private fileManagementService: FileManagementService,
              private platformToolSpreadsheetHandler: PlatformToolSpreadsheetHandler,
              private flexSheetDataService: FlexSheetDataService) {

  }

  ngOnInit(): void {
  }

  configureWorksheetPlaceHolder() {
    const command = new PlatformCommand('VirtualPlaceHolderWorksheetMappingCommand', this.flexSheetService.getApi());
    command.fieldValues['WorkbookId'] = this.flexSheetService.getCurrentWorkBook().id;
    command.fieldValues['WorksheetId'] = this.flexSheetService.getCurrentWorkSheet().id;
    // command.fieldValues["CommandName"] = 'VirtualPlaceHolderWorksheetMappingCommand';
    command.fieldValues['EventSourceId'] = this.flexSheetService.getCurrentWorkBookSetId();
    command.fieldValues['WorkbookSetId'] = this.flexSheetService.getCurrentWorkBookSetId();
    command.fieldValues['SourceType'] = 'WorkbookSet';
    this.platformToolSpreadsheetHandler.executeCommand(command);
  }
  openFileSelector() {
    const fieldValues = this.flexSheetService.getMagicLinkModel().fieldValues;
    const fileSelectorModel = new FileSelectorModel();
    fileSelectorModel.parentId = fieldValues['de-parentId'];
    fileSelectorModel.isClientDrive = fieldValues['isClientDrive'];
    fileSelectorModel.iconViewModels = [];
    fileSelectorModel.fileExtensionTypes = fieldValues['fileExtensionTypes'];
    fileSelectorModel.hideFiles = fieldValues['hideFiles'];
    fileSelectorModel.skipBreadcrumbItem = false;
    fileSelectorModel.returnType = fieldValues['RelativePath'];
    fileSelectorModel.foldersSelectable = false;
    fileSelectorModel.iconViewQueryName = 'DataExtractorFileIconViewQuery';
    fileSelectorModel.locked = fieldValues['FileSelectorLocked'];
    fileSelectorModel.deleteOption = fieldValues['FileSelectorDeleteOption'];
    fileSelectorModel.overwrite = fieldValues['OverwriteFile'];
    
    this.dialogService.showOrbitaxDriveFileSelector(fileSelectorModel).pipe(take(1)).subscribe(state => {
      if (state && state.action === 'OK') {
        const {name, relativePath, type, itemId} = state.data.input.selectedItems[0];
        if (type) {
          this.snackBarService.showInformation(`${name} selected successfully`);
          const command = new PlatformCommand('AddEventSourceModelCommand', this.flexSheetService.getApi());
          command.fieldValues['WorkbookId'] = this.flexSheetService.getCurrentWorkBook().id;
          command.fieldValues['FileId'] = itemId;
          command.fieldValues['Name'] = name;
          command.fieldValues['CommandName'] = 'UploadSourceFileCommand';
          command.fieldValues['EventSourceId'] = this.flexSheetService.getCurrentWorkBookSetId();
          command.fieldValues['WorkbookSetId'] = this.flexSheetService.getCurrentWorkBookSetId();
          command.fieldValues['SourceType'] = 'WorkbookSet';
          command.fieldValues['RelativePath'] = relativePath;
          this.flexSheetDataService.executeCommandToApi(command).pipe(take(1)).subscribe(x => {
            this.flexSheetService.getCurrentWorkBook().isPlaceHolder = false;
            this.configureWorksheetPlaceHolder();
          });

        } else {
          this.snackBarService.showError('Please select a folder or file');
        }
      }
    });
  }

  downloadFile(){
     this.fileManagementService.globalFileDownloadByRelativePath(this.flexSheetService.getCurrentWorkBook().globalFileRelativePath)
      .pipe(take(1)).subscribe((payload: any) => {
       this.fileManagementService.openSaveFileWindow(payload, this.flexSheetService.getCurrentWorkBook().fileName);
     },(error: any) => {

     });
  }

  isDownloadFileExists() {
    if(this.flexSheetService.getCurrentWorkBook()?.globalFileRelativePath) {
      return true;
    }
    return false;
  }

}
